export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/bbcfb7075095579a6add7f510a1d5d6d.jpg"
          alt="Network Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[#0A0E27]/80 via-[#1A0B2E]/70 to-[#0A0E27]/80"></div>
      </div>

      <div className="relative max-w-[1400px] mx-auto px-8 w-full">
        <div className="max-w-[55%] ml-[5%]">
          <div className="inline-block mb-8 px-5 py-2 bg-[#00D9FF]/20 backdrop-blur-sm rounded-md border border-[#00D9FF]/30">
            <span className="text-[#00D9FF] text-xs font-medium tracking-[3px] uppercase">
              / Enterprise VPN Solution
            </span>
          </div>

          <h1 className="mb-10">
            <div className="text-white text-[120px] font-bold leading-[1.1] tracking-tight">
              SECURE YOUR
            </div>
            <div className="text-[#00D9FF] text-[120px] font-bold italic leading-[1.1] tracking-tight">
              DIGITAL
            </div>
            <div className="text-white text-[120px] font-bold leading-[1.1] tracking-tight">
              PRESENCE
            </div>
          </h1>

          <div className="space-y-6 text-[#B8C5D6] text-2xl leading-[1.8] font-light max-w-[90%]">
            <p>
              Experience unparalleled online privacy and security with BRIMA's cutting-edge VPN technology. Our military-grade encryption ensures your digital footprint remains completely anonymous.
            </p>
            <p>
              Connect to our global network of high-speed servers and browse the internet without boundaries, restrictions, or surveillance. Your data, your privacy, your freedom.
            </p>
          </div>

          <button
            onClick={() => scrollToSection('pricing')}
            className="mt-12 px-10 py-5 bg-[#00D9FF] text-white text-lg font-semibold rounded-full hover:bg-[#00C4E6] transition-all duration-300 shadow-lg shadow-[#00D9FF]/30 whitespace-nowrap cursor-pointer"
          >
            Start Free Trial
          </button>
        </div>
      </div>

      <div className="absolute bottom-20 right-20 w-[400px] h-[400px] opacity-30">
        <div className="w-full h-full border-2 border-[#00D9FF] rounded-lg transform rotate-12 animate-pulse"></div>
        <div className="absolute inset-8 border-2 border-[#00D9FF] rounded-lg transform -rotate-6"></div>
        <div className="absolute inset-16 border-2 border-[#00D9FF] rounded-lg transform rotate-3"></div>
      </div>
    </section>
  );
}
